<template>
  <el-config-provider :link="{underline:'never'}" :locale="currentLocale" >
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </el-config-provider>

</template>
<script setup>
import { ref, onMounted } from 'vue'
import { dayjs } from 'element-plus'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/fr'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import fr from 'element-plus/es/locale/lang/fr'
import { useSysHeaderNoticeNumber } from './hooks'
import storage from 'store2'

const currentLocale = ref(en)

// 初始化时设置语言
function initLocale() {
  const locale = storage.get('locale')
  dayjs.locale(locale)
  if (locale === 'zh-cn') {
    currentLocale.value = zhCn
  } else if (locale === 'fr') {
    currentLocale.value = fr
  } else {
    currentLocale.value = en  // 默认英文
  }
}

onMounted(() => {
  initLocale()
})


onMounted(async () => {
  useSysHeaderNoticeNumber()
})


</script>

<style lang="scss">
html,
body {
  margin: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#app {
  font-weight: 400;
  color: #151515;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
